/*----- Imports -----*/
import React 			 from 'react'
import PropTypes 	 from 'prop-types'
import styled 		 from 'styled-components'
import { css } 		 from 'styled-components'
import { NavLink } from 'react-router-dom'

/*----- Commons-----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color 			from '../../commons/Color'

/*----- Components -----*/

/*----- Styles-----*/
const StyledDefaultButton = styled(NavLink)`
	${ Montserrat(14, 600, 'white') };
	height: 36px;
	border-radius: 30px;
	padding: 20px 24px;
	cursor: pointer;
	background: ${Color.main};
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 220px;
	border: none;
	transition: all 0.5s;
	&:focus {
		outline: none;
	}
	&:hover {
		color: white;
		box-shadow: 0px 8px 12px 0px rgba(50, 139, 255, 0.2);
	}

  ${props => props.invert && css`
		background: white;
		color: ${ Color.main };
		&:hover {
			color: ${ Color.main };
		}
  `}
	.default-button__icon {
		width: 16px;
		margin-right: 8px;
	}
`

/*----- Component -----*/
const DefaultButton = ({ content, destination, invert }) => {
  return(
		<StyledDefaultButton className="default-button" to={destination} invert={invert? 1 : 0}>
			{ content }
		</StyledDefaultButton>
  )
}
export default DefaultButton

/*----- PropTypes -----*/
DefaultButton.propTypes = {
	content: 		 PropTypes.string.isRequired,
	destination: PropTypes.string.isRequired,
	invert:      PropTypes.bool
}
